// extracted by mini-css-extract-plugin
export default {"module":"modal_module__fYiKI","content":"modal_content__yUpR3"};